import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { unsetToken, getCurrentUser, isImpersonating, stopImpersonating } from '../actions/auth';
import { history } from '../routers/AppRouter';
import { TEAM_LIVERY } from '../theme';
import { fullName } from '../scoring';
import logo from '../assets/tnp-bootcamp-logo.png';

const ATNVT_URL = 'https://automotivetrainingnetwork.lightspeedvt.com/';
const SURVEY_URL = 'https://atntraining.typeform.com/to/mmBSM9';

const navItems = (role) => [
  { to: '/dashboard', label: 'My customers' },
  { to: '/scoreboard', label: 'Scoreboard' },
  { to: '/teamdashboard', label: 'Teams' },
  { to: '/documents', label: 'Training docs' },
  ...(role === 'admin' || role === 'dealership_manager' ? [{ to: '/dealershipdashboard', label: 'Dealership' }] : []),
  ...(role === 'admin' ? [{ to: '/racecontrol', label: 'Race control' }, { to: '/admin', label: 'Admin' }] : []),
];

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const user = getCurrentUser() || {};
  const team = TEAM_LIVERY[Cookies.get('team')];
  const items = navItems(user.role);

  const go = (to) => {
    setDrawerOpen(false);
    history.push(to);
  };
  const openExternal = (url) => {
    setMenuAnchor(null);
    setDrawerOpen(false);
    window.open(url, '_blank', 'noopener');
  };

  return (
    <header className="topbar">
      {isImpersonating() && (
        <div className="impersonation-bar" role="status">
          <span>You’re logged in as <b>{fullName(user)}</b>. Anything you change is saved to their account.</span>
          <button type="button" onClick={stopImpersonating}>Return to my account</button>
        </div>
      )}
      <div className="topbar-inner">
        <IconButton className="menu-toggle" aria-label="Open navigation" onClick={() => setDrawerOpen(true)}
          sx={{ color: '#fff', ml: -1 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </IconButton>

        <Link to="/dashboard" className="wordmark">
          <img src={logo} alt="TNP Bootcamp" />
        </Link>

        <nav className="topnav" aria-label="Main">
          {items.map((item) => (
            <NavLink key={item.to} to={item.to} activeClassName="active">{item.label}</NavLink>
          ))}
        </nav>

        <div className="topbar-user">
          {team && (
            <span className="team-pill">
              <span className="team-swatch" style={{ background: team.color }} />
              {team.label} team
            </span>
          )}
          <Button
            onClick={(e) => setMenuAnchor(e.currentTarget)}
            aria-haspopup="menu"
            aria-label="Account menu"
            sx={{ color: '#fff', px: 1, minWidth: 0 }}
          >
            <span className="user-name">{fullName(user) || 'Account'}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ marginLeft: 4 }}>
              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
            </svg>
          </Button>
          <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={() => setMenuAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <MenuItem onClick={() => openExternal(ATNVT_URL)}>Open ATNVT</MenuItem>
            <MenuItem onClick={() => openExternal(SURVEY_URL)}>Post-bootcamp survey</MenuItem>
            <Divider />
            {isImpersonating()
              ? <MenuItem onClick={() => { setMenuAnchor(null); stopImpersonating(); }}>Return to my account</MenuItem>
              : <MenuItem onClick={() => { setMenuAnchor(null); unsetToken(); }}>Log out</MenuItem>}
          </Menu>
        </div>
      </div>

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <nav className="drawer-nav" aria-label="Main">
          <div className="drawer-head">
            {fullName(user)}
            {team && <small><span className="team-swatch" style={{ background: team.color }} />{team.label} team</small>}
          </div>
          <List>
            {items.map((item) => (
              <ListItemButton key={item.to} onClick={() => go(item.to)}
                selected={window.location.pathname === item.to}>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </List>
          <Divider />
          <List>
            <ListItemButton onClick={() => openExternal(ATNVT_URL)}><ListItemText primary="Open ATNVT" /></ListItemButton>
            <ListItemButton onClick={() => openExternal(SURVEY_URL)}><ListItemText primary="Post-bootcamp survey" /></ListItemButton>
            <ListItemButton onClick={() => { setDrawerOpen(false); unsetToken(); }}><ListItemText primary="Log out" /></ListItemButton>
          </List>
        </nav>
      </Drawer>
    </header>
  );
};

export default Header;
